import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import { fetchTravelInfo } from '../../lib/utils';

const TravelIndicator = ({ lat1, lon1, lat2, lon2 }) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (lat1 && lat2) {
      setLoading(true);
      fetchTravelInfo(lat1, lon1, lat2, lon2).then(res => {
        setInfo(res);
        setLoading(false);
      });
    } else {
      setInfo(null);
    }
  }, [lat1, lon1, lat2, lon2]);

  if (loading) return <div style={{ fontSize: 10, color: '#94a3b8', padding: '10px 0', fontStyle: 'italic' }}>Calcul de l'itinéraire estimé...</div>;
  if (!info) return null;

  const isLong = info.duration > 45;
  const color = isLong ? '#f59e0b' : '#22c55e';

  return (
    <div style={{ background: isLong ? '#fffbeb' : '#f0fdf4', border: '1px solid ' + (isLong ? '#fef3c7' : '#dcfce7'), borderRadius: 16, padding: '12px 16px', marginBottom: 15, display: 'flex', alignItems: 'center', gap: 12, animation: 'fadeIn 0.3s ease' }}>
      <div style={{ width: 36, height: 36, borderRadius: 12, background: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <MapPin size={20} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 900, color: '#0f172a' }}>{info.duration} min <span style={{ fontSize: 11, color: '#64748b', fontWeight: 600 }}>({info.distance} km)</span></div>
        <div style={{ fontSize: 10, color: '#64748b', fontWeight: 700 }}>Depuis la base de Lombez</div>
      </div>
      <a href={`https://www.google.com/maps/dir/${lat1},${lon1}/${lat2},${lon2}`} target="_blank" rel="noreferrer" style={{ background: '#fff', border: '1px solid #e2e8f0', padding: '6px 12px', borderRadius: 8, fontSize: 10, fontWeight: 800, color: '#0f172a', textDecoration: 'none', transition: 'all 0.2s' }}>Ouvrir Maps</a>
      <style>{`@keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }`}</style>
    </div>
  );
};

export default TravelIndicator;
